/*
 * @Descripttion:
 * @version:
 * @Author: mrh
 * @Date: 2021-07-16 11:21:03
 * @LastEditors: mrh
 * @LastEditTime: 2022-11-11 14:35:53
 */
import Vue from "vue";
import axios from "axios";
import Vconsole from "vconsole";
// if (process.env.NODE_ENV === 'development') {
//   let vConsole = new Vconsole()
//   Vue.use(vConsole)
// }
// process.env.NODE_ENV === "production" &&
// 开发环境中不上传错误日志
// Sentry.init({
//   dsn: 'https://f7e2fef5537745f3904d439c66cde3aa@o330936.ingest.sentry.io/5323476',
//   integrations: [new Integrations.Vue({ Vue, attachProps: true })],
//   release: 'test@1.0.1',
//   logErrors: true
// });
// console.log("66666")
 function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.href.split('?')[1] ? window.location.href.split('?')[1].match(reg) : null;
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}
const origin = window.location.origin;
let url = window.location.hash.split("#/")[1].split("?")[0];
console.log("url", window.location.hash.split("#/")[1].split("?")[0]);
axios.defaults.baseURL = window.location.origin; // 请求接口前缀
Vue.prototype.prefixURL = window.location.origin + "/";
Vue.prototype.imgPrex = "http://img.yamyamyam.com"; // 图片服务器前缀
Vue.prototype.pathType = 1; // 1悦买端 2店长端（本地环境自己手动修改参数值）
if (origin.indexOf("192.168.1.58") != -1) {
  // 悦买测试环境
  // 58环境下使用调试工具
  let vConsole = new Vconsole();
  Vue.use(vConsole);
  axios.defaults.baseURL = `${origin}/app`;
  Vue.prototype.prefixURL = `${origin}/app`;
} else if (origin.indexOf("192.168.1.59") != -1) {
  if (GetQueryString('source') == 'expert') {
     // 行家端
    axios.defaults.baseURL = "http://192.168.1.60:8112/";
    Vue.prototype.prefixURL = `http://192.168.1.60:8112/`;
    // console.log("source=expert目录行家端http://192.168.1.60:8112/")
  } else if (GetQueryString('source') == 2) {
    // 卖家
    axios.defaults.baseURL = "http://192.168.1.56:7212/";
    Vue.prototype.prefixURL = `http://192.168.1.56:7212/`; // 
    // console.log("source=2目录卖家http://192.168.1.56:7212/")
  } else {
    // 买家
    // axios.defaults.baseURL = "/dev/";
    axios.defaults.baseURL = "http://192.168.1.59:7210/app/";
    // axios.defaults.baseURL = "http://192.168.1.58:3000/mock/23/"; // 悦买端yapi地址
    Vue.prototype.prefixURL = `http://192.168.1.59:7210/app/`; // 悦买端
    // console.log("映射目录http://192.168.1.59:7210/app/即http://192.168.1.58:8080/app")
  }
  
} else if (window.location.host.indexOf("192.168.1.67") != -1) {
  // 店长测试环境
  // 60环境下使用调试工具
  // let vConsole = new Vconsole();
  // Vue.use(vConsole);
  axios.defaults.baseURL = "http://192.168.1.67/";
  Vue.prototype.prefixURL = "https://img.yamyamyam.com/mp/cstest/";
  Vue.prototype.pathType = 2;
} else if (
  origin.indexOf("localhost") != -1 ||
  origin.indexOf("127.0.0.1") != -1 ||
  origin.indexOf("192.168") != -1
) {
 
  if (GetQueryString('source') == 'expert') {
      // 行家端
    axios.defaults.baseURL = "http://192.168.1.60:8112/";
    Vue.prototype.prefixURL = `http://192.168.1.60:8112/`;
    // console.log("source=expert目录行家端http://192.168.1.60:8112/")
  } else if (GetQueryString('source') == 2 || url =='registerAgreement' || url=='getRuleContent') {
    // 卖家
    axios.defaults.baseURL = "http://192.168.1.56:7212/";
    Vue.prototype.prefixURL = `http://192.168.1.56:7212/`; // 
    // console.log("source=2目录卖家http://192.168.1.56:7212/")
  }else{
      // 本地环境
    axios.defaults.baseURL = "/dev/";
    // axios.defaults.baseURL = "http://192.168.1.59:7210/app/";
    // axios.defaults.baseURL = "http://192.168.1.58:3000/mock/23/"; // 悦买端yapi地址
    Vue.prototype.prefixURL = `http://192.168.1.59:7210/app/`; // 悦买端
    // axios.defaults.baseURL = "http://192.168.1.58:3000/mock/114/"; // 店长端yapi地址
    // Vue.prototype.prefixURL = "https://img.yamyamyam.com/mp/cstest/"; // 店长端
  }
} else if (origin.indexOf("testymstatic.yamyamyam.com") != -1) {
  //店长预先环境
  axios.defaults.baseURL = "https://testymapi.yamyamyam.com/"; //接口请求链接前缀
  Vue.prototype.prefixURL = "https://img.yamyamyam.com/mp/cshwready/"; ///分享链接前缀
  Vue.prototype.pathType = 2;
} else if (origin.indexOf("ymstatic.yamyamyam.com") != -1) {
  //店长线上环境(跟卖家一致，url的传参不一样，不知道为什么，历史遗留)
  if (window.location.href.indexOf("purchaseOrder") != -1) {
    axios.defaults.baseURL = "https://ymapi.yamyamyam.com/"; //接口请求链接前缀
  } else if (GetQueryString("source") && GetQueryString("source") == "expert" || url=='registerAgreement' || url=='getRuleContent') {
    // 行家
    axios.defaults.baseURL = "https://expert.yamyamyam.com/"; //接口请求链接前缀
  }else if(GetQueryString("source") == 2 && url!='registerAgreement' && url!='getRuleContent'){
    // 卖家
    axios.defaults.baseURL = "https://ymapi.yamyamyam.com/"; //接口请求链接前缀
  } else {
    axios.defaults.baseURL = "https://api.yamyamyam.com/"; //接口请求链接前缀
  }
  Vue.prototype.prefixURL = "https://img.yamyamyam.com/mp/cshwpro/"; ///分享链接前缀
  Vue.prototype.pathType = 1;
} else if (origin.indexOf("192.168.1.67") != -1) {
  //店长预先环境
  axios.defaults.baseURL = "http://192.168.1.67/app"; //接口请求链接前缀
  Vue.prototype.prefixURL = "http://192.168.1.67/app"; ///分享链接前缀
}